import PropTypes from 'prop-types';

export const ScannerStatusEnum = {
  SCHEDULED: {
    key: 'scheduled',
    label: 'Scheduled',
    cssStyle: 'statusScheduled'
  },
  QUEUED: { key: 'queued', label: 'Queued', cssStyle: 'statusQueued' },
  RUNNING: { key: 'running', label: 'Running', cssStyle: 'statusRunning' },
  IMPORTING: {
    key: 'importing',
    label: 'Importing',
    cssStyle: 'statusImporting'
  },
  STOPPED: { key: 'stopped', label: 'Stopped', cssStyle: 'statusStopped' },
  PAUSED: { key: 'paused', label: 'Paused', cssStyle: 'statusPaused' },
  // Extended statuses
  IDLE: { key: 'idle', label: 'Idle', cssStyle: 'statusIdle' },
  SCANNING: { key: 'scanning', label: 'Scanning', cssStyle: 'statusScanning' },
  REVIEW: { key: 'review', label: 'Needs review', cssStyle: 'statusReview' },
  UPDATING: { key: 'updating', label: 'Updating', cssStyle: 'statusUpdating' },
  // Fallback for scanner statuses not in UI enum
  UNKNOWN: { key: 'unknown', label: 'Unknown', cssStyle: 'statusUnknown' }
};

/**
 * Returns the ScannerStatusEnum object for a given key string value
 * @param {string} key
 * @returns {object|ScannerStatusEnum.UNKNOWN}
 */
export const getScannerStatusByKey = (key) => {
  if (!key || typeof key !== 'string') {
    return ScannerStatusEnum.UNKNOWN;
  }
  const normalizedKey = key.toLowerCase();
  const statusScannerInfo = Object.values(ScannerStatusEnum).find(
    (statusInfo) => statusInfo.key.toLowerCase() === normalizedKey
  );

  // Return UNKNOWN status as fallback if not found
  return statusScannerInfo || ScannerStatusEnum.UNKNOWN;
};

export const RunStatusEnum = {
  COMPLETED: {
    key: 'completed',
    label: 'Completed',
    cssStyle: 'statusRunCompleted'
  },
  PARTIAL_SUCCESS: {
    key: 'partialsuccess',
    label: 'Partial success',
    cssStyle: 'statusRunPartialSuccess'
  },
  FAILED: { key: 'failed', label: 'Failed', cssStyle: 'statusRunFailed' },
  ABORTED: { key: 'aborted', label: 'Aborted', cssStyle: 'statusRunAborted' },
  // Extended statuses
  RUNNING: { key: 'running', label: 'Running', cssStyle: 'statusRunRunning' },
  IMPORTING: {
    key: 'importing',
    label: 'Importing',
    cssStyle: 'statusRunImporting'
  },
  // Fallback for run statuses not in UI enum
  UNKNOWN: { key: 'unknown', label: 'Unknown', cssStyle: 'statusRunUnknown' }
};

/**
 * Returns the RunStatusEnum object for a given key string value
 * @param {string} key
 * @returns {object|RunStatusEnum.UNKNOWN}
 */
export const getRunStatusByKey = (key) => {
  if (!key || typeof key !== 'string') {
    return RunStatusEnum.UNKNOWN;
  }
  const normalizedKey = key.toLowerCase();
  const statusRunInfo = Object.values(RunStatusEnum).find(
    (statusInfo) => statusInfo.key.toLowerCase() === normalizedKey
  );

  // Return UNKNOWN status as fallback if not found
  return statusRunInfo || RunStatusEnum.UNKNOWN;
};

export const filterOptions = (() => {
  const options = [{ value: 'any', label: 'All statuses' }];

  for (const scannerStatusInfo of Object.values(ScannerStatusEnum)) {
    // e.g. expected option to add: { value: 'scheduled', label: 'Scheduled' }
    options.push({
      value: scannerStatusInfo.key,
      label: scannerStatusInfo.label
    });
  }

  return options;
})();

export const ScanConfigurationPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  connection: PropTypes.object.isRequired,
  pendingActions: PropTypes.number.isRequired,
  creationDate: PropTypes.string.isRequired
});

export const dateFormat = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric'
};

// Number of items per page in the scan configurations list (pagination)
export const ITEMS_PER_PAGE = 3;
